import { render, staticRenderFns } from "./truckDriver_page.vue?vue&type=template&id=f91aca6e&scoped=true"
import script from "./truckDriver_page.vue?vue&type=script&lang=js"
export * from "./truckDriver_page.vue?vue&type=script&lang=js"
import style0 from "./truckDriver_page.vue?vue&type=style&index=0&id=f91aca6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91aca6e",
  null
  
)

export default component.exports